import {
  ArbeitenBezeichnungen,
  ArbeitenData,
  GetArbeitenResponse
} from '@/types/service-response'
import { UiLanguageItem } from '@/types'
import store from '@/store'

export class Task {
  private constructor (
    readonly id: number,
    readonly name: string
  ) {}

  public static createListFromResponse (data: GetArbeitenResponse): Task[] {
    return data.Arbeiten.map((item: ArbeitenData): Task => {
      const selectedLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
      let workDescription : string = ''
      if(selectedLanguage) {
        const foundDescription: ArbeitenBezeichnungen | undefined = item.Bezeichnungen.find((item: ArbeitenBezeichnungen) => item.Sprache === selectedLanguage.syzId)
        workDescription =  foundDescription ? foundDescription.Bezeichnung : ''
      }

      return new Task(
        item.ID,
        workDescription
      )
    })
  }
}
